import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';

@Component({
    selector: 'feature-page-layout-b2c-access-forbidden',
    templateUrl: './b2c-access-forbidden.component.html',
    styleUrls: ['./b2c-access-forbidden.component.css'],
    standalone: false
})
export class B2cAccessForbiddenComponent extends StaticPropsComponentExtensions {
  constructor(private router: Router) {
    super();
  }
  navigate(): void {
    this.router.navigate(['user-not-found']);
  }
}
